var app = angular.module("leonardo");

var FiltersOverviewController = function (
  $scope,
  ReportService,
  PropertyService,
  $controller,
  CacheService
) {


$controller('FiltersBaseController', { $scope: $scope });

  $scope.filters_options = [
    {
      group: 'hierarchy',
      name: 'By Hierarchy',
      elements: [
        {
          id: 'account_reports',
          name: 'Account',
          label: null,
          inline: false,
          type: 'options',
          multiple: true,
          placeholder: 'All Accounts',
          condition: $scope.filterService.accounts.length > 1,
          options: $scope.filterService.accounts,
          conflicts: ['property_reports', 'portfolio_reports', 'group_reports', 'managed_by_reports']
        },
        {
          id: 'managed_by_reports',
          name: 'Management Company',
          label: null,
          inline: false,
          type: 'options',
          multiple: true,
          placeholder: 'All Management Companies',
          condition: $scope.filterService.managers.length > 1,
          options: $scope.filterService.managers,
          conflicts: ['property_reports', 'portfolio_reports', 'group_reports', 'account_reports']
        },
        {
          id: 'group_reports',
          name: 'Property Group',
          label: null,
          inline: false,
          type: 'options',
          multiple: true,
          placeholder: 'All Groups',
          condition: $scope.filterService.groups.length > 1 && !$scope.only_account,
          options: $scope.filterService.groups,
          conflicts: ['property_reports', 'portfolio_reports', 'managed_by_reports', 'account_reports']
        },
        {
          id: 'portfolio_reports',
          name: 'Portfolio',
          label: null,
          inline: false,
          type: 'options',
          multiple: true,
          placeholder: 'All Portfolios',
          condition: $scope.filterService.portfolios.length > 1 && !$scope.only_account,
          options: $scope.filterService.portfolios,
          conflicts: ['property_reports', 'group_reports', 'managed_by_reports', 'account_reports']
        },
        {
          id: 'property_reports',
          name: 'Property',
          label: null,
          inline: false,
          type: 'property_selector',
          multiple: true,
          placeholder: 'All Properties',
          condition: $scope.filterService.properties.length > 1 && !$scope.only_account,
          options: $scope.filterService.properties,
          conflicts: ['portfolio_reports', 'group_reports', 'managed_by_reports', 'account_reports']
        }
      ]
    },
    {
      id: 'category',
      name: 'Category',
      label: null,
      inline: false,
      type: 'options',
      multiple: true,
      placeholder: 'All Categories',
      condition: true,
      options: CacheService.get('categories'),
      conflicts: ['sector']
    },
    {
      id: 'priority',
      name: 'Priority',
      label: null,
      inline: false,
      type: 'options',
      multiple: true,
      placeholder: 'All Priorities',
      condition: true,
      options: ReportService.PRIORITY_OPTIONS,
      conflicts: []
    },
    {
      id: 'property_status',
      name: 'Property Status',
      label: null,
      inline: false,
      type: 'options',
      multiple: true,
      placeholder: 'All Status',
      condition: true,
      options: PropertyService.PROGRESS_STATUS_OPTIONS,
      conflicts: []
    }
  ];

  $scope.filterService.showFilters(['property_reports', 'category', 'priority', 'property_status']);
};

app.controller('FiltersOverviewController', [
  '$scope',
  'ReportService',
  'PropertyService',
  '$controller',
  'CacheService',
  FiltersOverviewController
]);